var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { loginApi } from "apis/eduidLogin";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppSelector } from "eduid-hooks";
import { FormattedMessage } from "react-intl";
export function LoginAbortButton() {
    const loginRef = useAppSelector((state) => state.login.ref);
    const [fetchAbort] = loginApi.useLazyFetchAbortQuery();
    function handleOnClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault(); // don't submit the form when this button is clicked
            if (loginRef) {
                fetchAbort({ ref: loginRef });
            }
        });
    }
    return (_jsx(EduIDButton, { type: "button", buttonstyle: "secondary", onClick: handleOnClick, id: "login-abort-button", children: _jsx(FormattedMessage, { id: "common.cancel", defaultMessage: "Cancel", description: "button cancel" }) }));
}
